import { setTerms } from './helpers';

export const setInputType = setTerms('input_type');
